import { ActionReducerMap } from '@ngrx/store';
import { ILoginState } from './login/login';
import { loginReducer } from './login/login.reducer';
import { IConfigState } from './config/config';
import { configReducer } from './config/config.reducer';
import { IThirdPartyReportState } from './third-party-report/third-party-report';
import { thirdPartyReportReducer } from './third-party-report/third-party-report.reducer';
import { anagraphicReducer } from './anagraphic/anagraphic.reducer';
import { IAnagraphicState } from './anagraphic/anagraphic';
import { rendicontazioniReducer } from './rendicontazione/rendicontazione.reducer';
import { IRendicontazioniState } from './rendicontazione/rendicontazione';
import { monitoringReducer } from './monitoring/monitoring.reducer';
import { IMonitoringState } from './monitoring/monitoring';
import { IUtilitiesState } from './utilities/utilities';
import { utilitiesReducer } from './utilities/utilities.reducer';
import { ICommunicationState } from './communication/communication';
import { communicationReducer } from './communication/communication.reducer';
import { IMassiveUploadState } from './massive-upload/massive-upload';
import { massiveUploadReducer } from './massive-upload/massive-upload.reducer';
//139172 – Tool per la rilevazione stato del PuntoPoste
import { clusterReducer } from './cluster/cluster.reducer';
import { IClusterState } from './cluster/cluster';


export interface AppState {
  config: IConfigState;
  login: ILoginState;
  thirdPartyReport: IThirdPartyReportState;
  anagraphic: IAnagraphicState;
  rendicontazioni: IRendicontazioniState;
  monitoring: IMonitoringState;
  utilities: IUtilitiesState;
  communication: ICommunicationState;
  massiveUpload: IMassiveUploadState;
  cluster: IClusterState;
}

export const rootReducers: ActionReducerMap<AppState> = {
  config: configReducer,
  login: loginReducer,
  thirdPartyReport: thirdPartyReportReducer,
  anagraphic: anagraphicReducer,
  rendicontazioni: rendicontazioniReducer,
  monitoring: monitoringReducer,
  utilities: utilitiesReducer,
  communication: communicationReducer,
  massiveUpload: massiveUploadReducer,
  cluster: clusterReducer
};
